<form class="container-fluid py-3">
	<!-- Header fijo y limpio -->
	<div class="card shadow-sm border-0 mb-3">
		<div class="card-body">
			<div
				class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3"
			>
				<div>
					<h5 class="mb-0">Reporte KPI</h5>
					<div class="text-muted small">
						{{
							previsualizar ? "Previsualización" : "Configuración"
						}}
					</div>
				</div>

				<!-- Acciones globales -->
				<div
					class="d-flex gap-2 align-items-center justify-content-lg-end"
				>
					<!-- Modo edición -->
					<ng-container *ngIf="!previsualizar">
						<button
							type="button"
							class="btn btn-primary"
							(click)="generarReporte()"
							[disabled]="!isValid()"
							title="Previsualizar reporte"
						>
							<i class="bi bi-eye me-1"></i>
							Previsualizar
						</button>
					</ng-container>

					<!-- Modo preview -->
					<ng-container *ngIf="previsualizar">
						<button
							type="button"
							class="btn btn-outline-primary"
							(click)="editParameters()"
							title="Regresar a editar parámetros"
						>
							<i class="bi bi-pencil-square me-1"></i>
							Editar
						</button>
					</ng-container>

					<ng-container *ngIf="previsualizar">
						<button
							type="button"
							class="btn btn-outline-primary"
							(click)="downloadReport()"
							title="Regresar a editar parámetros"
						>
							<i class="bi bi-pencil-square me-1"></i>
							Imprimir Reporte
						</button>
					</ng-container>
				</div>
			</div>

			<!-- Indicador simple de pasos -->
			<div class="mt-3">
				<div class="d-flex align-items-center gap-2">
					<span
						class="badge rounded-pill"
						[class.text-bg-primary]="!previsualizar"
						[class.text-bg-light]="previsualizar"
						>1</span
					>
					<span class="small">Parámetros</span>
					<span class="text-muted">›</span>
					<span
						class="badge rounded-pill"
						[class.text-bg-primary]="!previsualizar"
						[class.text-bg-light]="previsualizar"
						>2</span
					>
					<span class="small">Detalle</span>
					<span class="text-muted">›</span>
					<span
						class="badge rounded-pill"
						[class.text-bg-primary]="previsualizar"
						[class.text-bg-light]="!previsualizar"
						>3</span
					>
					<span class="small">Preview</span>
				</div>
			</div>
		</div>
	</div>

	<!-- ========================= -->
	<!-- MODO EDICIÓN -->
	<!-- ========================= -->
	<ng-container *ngIf="!previsualizar">
		<!-- Parámetros -->
		<div class="card shadow-sm border-0 mb-3">
			<div class="card-body">
				<div class="row g-3 align-items-end">
					<!-- Cliente -->
					<div *ngIf="isAdmin" class="col-12 col-lg-4">
						<label class="form-label fw-semibold mb-1"
							>Cliente</label
						>
						<p-dropdown
							[options]="clientes"
							optionLabel="nombre_comercial"
							optionValue="id"
							[(ngModel)]="client_id"
							name="client_id"
							styleClass="p-dropdown-sm w-100"
							[filter]="true"
							placeholder="Selecciona un cliente"
							(onChange)="getMediasByClient($event)"
							appendTo="body"
						></p-dropdown>
						<div
							class="text-danger small mt-1"
							*ngIf="submitted && !client_id"
						>
							El cliente es requerido.
						</div>
					</div>

					<!-- Nombre -->
					<div class="col-12 col-lg-4">
						<label class="form-label fw-semibold mb-1"
							>Nombre del reporte</label
						>
						<input
							type="text"
							class="form-control"
							[(ngModel)]="nombreReporte"
							name="nombreReporte"
							placeholder="Ej. Reporte febrero 2026"
						/>
						<div
							class="text-danger small mt-1"
							*ngIf="submitted && !nombreReporte?.trim()"
						>
							El nombre del reporte es requerido.
						</div>
					</div>

					<!-- Fechas -->
					<div class="col-12 col-md-6 col-lg-2">
						<label class="form-label fw-semibold mb-1"
							>Inicio</label
						>
						<input
							type="date"
							class="form-control"
							[(ngModel)]="fechaInicio"
							name="fechaInicio"
						/>
						<div
							class="text-danger small mt-1"
							*ngIf="submitted && !fechaInicio"
						>
							Requerido.
						</div>
					</div>

					<div class="col-12 col-md-6 col-lg-2">
						<label class="form-label fw-semibold mb-1">Fin</label>
						<input
							type="date"
							class="form-control"
							[(ngModel)]="fechaFin"
							name="fechaFin"
						/>
						<div
							class="text-danger small mt-1"
							*ngIf="submitted && !fechaFin"
						>
							Requerido.
						</div>
					</div>
				</div>

				<!-- Estado -->
				<div
					class="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3 pt-3 border-top"
				>
					<div class="d-flex align-items-center gap-2">
						<span class="badge text-bg-light border">
							Filas: {{ filas.length }}
						</span>
						<span
							class="badge text-bg-light border"
							*ngIf="client_id"
						>
							Cliente OK
						</span>
					</div>

					<div
						class="small fw-semibold"
						[class.text-success]="isValid()"
						[class.text-danger]="!isValid()"
					>
						{{
							isValid()
								? "Listo para previsualizar"
								: "Complete los campos requeridos"
						}}
					</div>
				</div>
			</div>
		</div>

		<!-- Detalle -->
		<div class="card shadow-sm border-0">
			<div class="card-header bg-white border-0">
				<div class="d-flex justify-content-between align-items-center">
					<div class="fw-semibold">Detalle de Medias</div>
					<span class="text-muted small" *ngIf="client_id"
						>Seleccione media + servicio</span
					>
				</div>
			</div>

			<div class="card-body">
				<!-- Sin cliente -->
				<div
					*ngIf="isAdmin && !client_id"
					class="alert alert-info mb-3"
				>
					Seleccione un cliente para cargar sus medias.
				</div>

				<div class="table-responsive" *ngIf="!isAdmin || client_id">
					<table class="table align-middle">
						<thead class="table-light">
							<tr>
								<th style="min-width: 320px">Media</th>
								<th style="min-width: 340px">Servicio</th>
								<th class="text-end" style="width: 80px"></th>
							</tr>
						</thead>

						<tbody>
							<tr *ngFor="let fila of filas; let i = index">
								<td>
									<p-dropdown
										[options]="mediasfiltered"
										optionValue="id"
										[(ngModel)]="fila.mediaId"
										optionLabel="name"
										[name]="'mediaId_' + i"
										styleClass="p-dropdown-sm w-100"
										[filter]="true"
										filterBy="name"
										placeholder="Selecciona una media"
										appendTo="body"
									>
										<ng-template let-media pTemplate="item">
											{{ media.id }} - {{ media.name }}
										</ng-template>

										<ng-template
											let-media
											pTemplate="selectedItem"
										>
											{{ media?.id }} - {{ media?.name }}
										</ng-template>
									</p-dropdown>

									<div
										class="text-danger small mt-1"
										*ngIf="submitted && !fila.mediaId"
									>
										Seleccione una media.
									</div>
								</td>

								<td>
									<p-dropdown
										[options]="serviceTypes"
										optionLabel="label"
										optionValue="key"
										[(ngModel)]="fila.serviceKey"
										[name]="'serviceKey_' + i"
										styleClass="p-dropdown-sm w-100"
										placeholder="Selecciona un servicio"
										appendTo="body"
									></p-dropdown>

									<div
										class="text-danger small mt-1"
										*ngIf="submitted && !fila.serviceKey"
									>
										Seleccione un servicio.
									</div>
								</td>

								<td class="text-end">
									<button
										type="button"
										class="btn btn-outline-danger btn-sm"
										(click)="removeFila(i)"
										[disabled]="filas.length === 1"
										title="Eliminar fila"
									>
										<i class="pi pi-trash"></i>
									</button>
								</td>
							</tr>
						</tbody>
					</table>

					<!-- Acción “Agregar fila” en el lugar correcto -->
					<div class="d-flex justify-content-start mt-2">
						<button
							type="button"
							class="btn btn-outline-primary"
							(click)="addFila()"
							title="Agregar otra media"
						>
							<i class="bi bi-plus-lg me-1"></i>
							Agregar media
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-container>

	<!-- ========================= -->
	<!-- MODO PREVISUALIZAR -->
	<!-- ========================= -->
	<ng-container *ngIf="previsualizar">
		<div class="card shadow-sm border-0">
			<div class="card-body">
				<!-- Resumen general -->
				<div
					class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-3"
				>
					<div>
						<div class="fw-semibold">Previsualización</div>
						<div class="text-muted small">
							{{ getClienteNombre() }} · {{ fechaInicio }} →
							{{ fechaFin }} · Medias:
							{{ getPreviewGroups().length }}
						</div>
					</div>
					<span class="badge text-bg-light border">
						Registros: {{ previewSource?.length || 0 }}
					</span>
				</div>

				<div
					*ngIf="getPreviewGroups().length === 0"
					class="alert alert-warning mb-0"
				>
					No hay información para este rango / selección.
				</div>

				<!-- Tablas por media -->
				<div
					*ngFor="let g of previewGroupsWithCharts"
					class="card shadow-sm border-0 mb-3"
				>
					<!-- Header por media -->
					<div class="card-header bg-white border-0 kpi-media-header">
						<div class="row g-3 align-items-start">
							<!-- Columna principal -->
							<div class="col-12 col-xl-9">
								<!-- Título -->
								<div
									class="d-flex flex-column flex-md-colum justify-content-between align-items-md-start gap-2 mb-3 kpi-stat-card"
								>
									<div>
										<div class="kpi-stat-label">Media</div>
										<div class="kpi-stat-value">
											{{ g.media_nombre }}
										</div>
										<div class="kpi-stat-value2">
											<span
												class="badge rounded-pill kpi-stat-value2"
												*ngFor="let c of g.categorias"
											>
												{{ c.category_nombre }}
											</span>
										</div>
									</div>

									<!-- <div class="d-flex flex-wrap gap-2 kpi-stat-card">
										<span
											class="badge rounded-pill kpi-stat-value"
											*ngFor="let c of g.categorias"
										>
											{{ c.category_nombre }}
										</span>
									</div> -->
								</div>

								<div *ngIf="g.resumen; else sinResumen">
									<!-- KPIs principales -->
									<div class="row g-3 mb-3">
										<div class="col-4 col-lg-4">
											<div class="kpi-stat-card">
												<div class="kpi-stat-label">
													Unidades
												</div>
												<div class="kpi-stat-value">
													{{ g.rows.length }}
												</div>
											</div>
										</div>

										<div class="col-4 col-lg-4">
											<div class="kpi-stat-card">
												<div class="kpi-stat-label">
													Reproducciones
												</div>
												<div class="kpi-stat-value">
													{{
														g.resumen
															.total_reproducciones
													}}
												</div>
											</div>
										</div>

										<div class="col-4 col-lg-4">
											<div class="kpi-stat-card">
												<div class="kpi-stat-label">
													Segundos totales
												</div>
												<div class="kpi-stat-value">
													{{ g.total_segundos }}
												</div>
											</div>
										</div>
									</div>
									<div class="row g-3 mb-3">
										<div class="col-6 col-lg-3">
											<div class="kpi-stat-card">
												<div class="kpi-stat-label">
													Duración
												</div>
												<div class="kpi-stat-value">
													{{
														g.resumen
															.duration_seconds
													}}
												</div>
											</div>
										</div>
										<div class="col-6 col-lg-3">
											<div class="kpi-stat-card">
												<div class="kpi-stat-label">
													Unidades spot
												</div>
												<div class="kpi-stat-value">
													{{
														g.resumen.unidades_spot
													}}
												</div>
											</div>
										</div>
										<div class="col-6 col-lg-3">
											<div class="kpi-stat-card">
												<div class="kpi-stat-label">
													Unidades spot totales
												</div>
												<div class="kpi-stat-value">
													{{
														g.resumen
															.unidades_spot_totales
													}}
												</div>
											</div>
										</div>
									</div>

									Desgloses
									<div class="row g-3" *ngIf="isAdmin">
										<!-- Reproducciones por grupo -->
										<div class="col-12 col-lg-6">
											<div class="kpi-info-box h-100">
												<div
													class="kpi-info-title mb-2"
												>
													Reproducciones por grupo
												</div>

												<div class="row g-2">
													<div
														*ngFor="
															let pg of g.resumen
																.por_grupo
														"
														class="col-6"
													>
														<div
															class="kpi-mini-card"
														>
															<div
																class="kpi-mini-label"
															>
																{{
																	pg.group_nombre
																}}
															</div>
															<div
																class="kpi-mini-value"
															>
																{{
																	pg.total_reproducciones
																}}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<!-- Reproducciones por campaña -->
										<div class="col-12 col-lg-6">
											<div class="kpi-info-box h-100">
												<div
													class="kpi-info-title mb-2"
												>
													Reproducciones por campaña
												</div>

												<div class="row g-2">
													<div
														*ngFor="
															let pr of g.resumen
																.por_reel
														"
														class="col-6"
													>
														<div
															class="kpi-mini-card"
														>
															<div
																class="kpi-mini-label"
															>
																{{
																	pr.reel_nombre
																}}
															</div>
															<div
																class="kpi-mini-value"
															>
																{{
																	pr.total_reproducciones
																}}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<ng-template #sinResumen>
									<div class="alert alert-light border mb-0">
										<span class="text-muted"
											>Sin resumen disponible para esta
											media.</span
										>
									</div>
								</ng-template>
							</div>
							<!-- 
							Columna lateral
							<div class="col-12 col-xl-3">
								<div class="kpi-side-panel">
									 <div class="kpi-side-item">
										<div class="kpi-side-label">
											Duración
										</div>
										<div class="kpi-side-value">
											{{ g.resumen.duration_seconds }}
										</div>
									</div>
									<div class="kpi-info-box h-100">
										<div class="kpi-info-title mb-2">
											Reproducciones por grupo
										</div>

										<div class="row g-2">
											<div
												*ngFor="
													let pg of g.resumen
														.por_grupo
												"
												class="col-12"
											>
												<div class="kpi-mini-card">
													<div class="kpi-mini-label">
														{{ pg.group_nombre }}
													</div>
													<div class="kpi-mini-value">
														{{
															pg.total_reproducciones
														}}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="kpi-info-box h-100">
												<div
													class="kpi-info-title mb-2"
												>
													Reproducciones por campaña
												</div>

												<div class="row g-2">
													<div
														*ngFor="
															let pr of g.resumen
																.por_reel
														"
														class="col-12"
													>
														<div
															class="kpi-mini-card"
														>
															<div
																class="kpi-mini-label"
															>
																{{
																	pr.reel_nombre
																}}
															</div>
															<div
																class="kpi-mini-value"
															>
																{{
																	pr.total_reproducciones
																}}
															</div>
														</div>
													</div>
												</div>
											</div>
								</div>
							</div> -->
						</div>
					</div>

					<!-- Bloque de acciones de la media -->
					 <div class="d-flex">
						 <div
							 class="kpi-table-toggle-bar px-3 pb-2 d-flex flex-column align-items-center"
						 >
							 <!-- Indicador de unidades -->
							 <div
								 class="kpi-stat-value d-flex align-items-center gap-2"
							 >
								 <span class="kpi-stat-label">Unidades</span>
								 <span class="kpi-stat-badge">
									 {{ g.rows.length }}
								 </span>
							 </div>
	 
							 <!-- Botón toggle -->
							 <button
								 type="button"
								 class="kpi-toggle-btn d-flex align-items-center gap-2"
								 (click)="toggleMediaTable(g.media_id)"
								 [attr.aria-expanded]="!isMediaTableOpen(g.media_id)"
								 [title]="
									 !isMediaTableOpen(g.media_id)
										 ? 'Ocultar detalle'
										 : 'Mostrar detalle'
								 "
							 >
								 <span class="kpi-toggle-icon">
									 <span
										 class="kpi-toggle-line"
										 [class.open]="!isMediaTableOpen(g.media_id)"
									 ></span>
									 <span
										 class="kpi-toggle-line"
										 [class.open]="!isMediaTableOpen(g.media_id)"
									 ></span>
									 <span
										 class="kpi-toggle-line"
										 [class.open]="!isMediaTableOpen(g.media_id)"
									 ></span>
								 </span>
	 
								 <span class="kpi-toggle-text">
									 {{
										 !isMediaTableOpen(g.media_id)
											 ? "Ocultar"
											 : "Ver"
									 }}
								 </span>
							 </button>
						 </div> 
					 </div>

					<!-- Contenedor colapsable de la tabla -->
					<div
						class="kpi-table-collapse"
						[class.open]="!isMediaTableOpen(g.media_id)"
					>
						<div class="kpi-table-collapse-inner">
							<div class="card-body p-0">
								<div class="table-responsive">
									<table
										class="table table-sm align-middle mb-0"
									>
										<thead class="table-light">
											<tr>
												<th style="min-width: 180px">
													Unidad
												</th>
												<th
													class="text-end"
													style="min-width: 120px"
												>
													Reps
												</th>
												<th
													class="text-end"
													style="min-width: 120px"
												>
													Segundos
												</th>
												<th
													class="text-end"
													style="min-width: 160px"
												>
													Días con rep.
												</th>
												<th
													class="text-end"
													style="min-width: 220px"
												>
													Prom diario (días con rep.)
												</th>
												<th style="min-width: 220px">
													Periodo
												</th>
											</tr>
										</thead>

										<tbody>
											<tr *ngFor="let r of g.rows">
												<td>
													<div class="fw-semibold">
														{{ r.unidad }}
													</div>
												</td>

												<td class="text-end">
													{{ r.total_reproducciones }}
												</td>
												<td class="text-end">
													{{
														r.segundos_reproducidos
													}}
												</td>

												<td class="text-end">
													{{
														r.dias_con_reproduccion
													}}
													/
													{{ r.dias_periodo }}
												</td>

												<td class="text-end">
													{{
														r.promedio_reproducciones_diarias_dias_con_reproduccion
													}}
												</td>

												<td>
													<div>
														<small
															class="text-muted"
															>Inicio:</small
														>
														{{ r.periodo_inicio }}
													</div>
													<div>
														<small
															class="text-muted"
															>Fin:</small
														>
														{{ r.periodo_fin }}
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div class="row g-3 p-3">
						<!-- Tarjeta Donut -->
						<div class="col-12 col-lg-5">
							<div class="card shadow-sm border-0 h-100">
								<div class="card-header bg-white border-0">
									<h6 class="mb-0">Distribución</h6>
								</div>
								<div class="card-body">
									<div class="w-100" style="height: 380px">
										<canvas
											baseChart
											[datasets]="g.donutDatasets"
											[labels]="g.donutLabels"
											[options]="doughnutOptionsByMedia"
											[legend]="true"
											[chartType]="'doughnut'"
										>
										</canvas>
									</div>
								</div>
							</div>
						</div>

						<!-- Tarjeta Comparativo reproducciones-->
						<div
							class="col-12 col-lg-6"
							*ngIf="
								g.resumen.reproducciones_contratadas > 1 &&
								g.resumen.total_reproducciones >
									g.resumen.reproducciones_contratadas
							"
						>
							<div class="card shadow-sm border-0 h-100">
								<div class="card-header bg-white border-0">
									<h6 class="mb-0">
										Comparació De Reproducciones
									</h6>
								</div>
								<div class="card-body">
									<div class="w-100" style="height: 300px">
										<canvas
											baseChart
											[datasets]="g.comparisonBarDatasets"
											[labels]="g.comparisonBarLabels"
											[options]="
												comparisonBarOptionsByMedia
											"
											[legend]="false"
											[chartType]="'bar'"
										>
										</canvas>
									</div>
								</div>
							</div>
						</div>

						<!-- Tarjeta Comparativo duracion-->
						<div
							class="col-12 col-lg-6"
							*ngIf="g.resumen.unidades_spot > 1"
						>
							<div class="card shadow-sm border-0 h-100">
								<div class="card-header bg-white border-0">
									<h6 class="mb-0">
										Comparativo por Duración
									</h6>
								</div>
								<div class="card-body">
									<div class="w-100" style="height: 300px">
										<canvas
											baseChart
											[datasets]="
												g.comparisonBarDurationdatasets
											"
											[labels]="
												g.comparisonBarDurationLabels
											"
											[options]="
												comparisonBarOptionsByMedia
											"
											[legend]="false"
											[chartType]="'bar'"
										>
										</canvas>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</form>
